var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass: "load-more-container",
          on: {
            click: function($event) {
              return _vm.loadMore()
            }
          }
        },
        [_vm._m(0)]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "a",
        {
          staticClass: "mx-auto mb-4 load-more-btn",
          on: {
            click: function($event) {
              return _vm.loadMore()
            }
          }
        },
        [_vm._v("mehr Artikel laden")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "action-container" }, [
      _c("div", { staticClass: "action" }, [
        _c("div", { staticClass: "action-icon" })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78c1f754", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78c1f754","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/LoadMore.vue
// module id = 628
// module chunks = 0